import { FacetFilter, FacetFilterType, useFacetsFilters } from '@/app/composable';
import { AssetTypeId } from '@/modules/asset/constants';
import { computed } from '@vue/composition-api';
import { ExpectedUsage, ExpectedUsageText, ReimbursementMethod, ReimbursementMethodText } from '../constants';

export function useContractFacets(get: any) {
    const { valueLabel, reducedFacetsFilters, defaultValue } = useFacetsFilters();

    const contractFacets = computed(
        (): Record<string, FacetFilter> => ({
            status: {
                label: 'Status',
                type: FacetFilterType.Checkbox,
                default: defaultValue(get, 'status'),
                valueLabel,
            },
            type: {
                label: 'Contract Type',
                type: FacetFilterType.Checkbox,
                default: defaultValue(get, 'type'),
                valueLabel,
            },
            reimbursementMethod: {
                label: 'Reimbursement Method',
                type: FacetFilterType.Checkbox,
                default: defaultValue(get, 'reimbursementMethod'),
                valueLabel: (value: ReimbursementMethod) => ReimbursementMethodText[value],
            },
            expectedUsage: {
                label: 'Expected Usage',
                type: FacetFilterType.Checkbox,
                default: defaultValue(get, 'expectedUsage'),
                valueLabel: (value: ExpectedUsage) => ExpectedUsageText[value],
            },
            assetType: {
                label: 'Asset Type',
                type: FacetFilterType.Checkbox,
                default: defaultValue(get, 'assetType'),
                valueLabel: (id: number) => {
                    switch (id) {
                        case AssetTypeId.Dataset:
                            return 'Dataset';
                        case AssetTypeId.Result:
                            return 'Result';
                        case AssetTypeId.Model:
                            return 'Model';
                        default:
                            return '';
                    }
                },
            },
            assetTimeliness: {
                label: 'Asset Timeliness',
                type: FacetFilterType.Checkbox,
                default: defaultValue(get, 'assetTimeliness'),
                valueLabel,
            },
        }),
    );

    const reducedContractFacets: any = reducedFacetsFilters(contractFacets);

    return { contractFacets, reducedContractFacets };
}
